
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceHsnGrid extends Serenity.EntityGrid<InvoiceHsnRow, any> {
        protected getColumnsKey() { return InvoiceHsnColumns.columnsKey; }
        protected getDialogType() { return InvoiceHsnDialog; }
        protected getIdProperty() { return InvoiceHsnRow.idProperty; }
        protected getInsertPermission() { return InvoiceHsnRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceHsnRow.localTextPrefix; }
        protected getService() { return InvoiceHsnService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {
            this.editItem({ InvoiceId: this.InvoiceId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.InvoiceId != null;
        }

        private _InvoiceId: number;

        get InvoiceId() {
            return this._InvoiceId;
        }

        set InvoiceId(value: number) {
            //debugger;
            if (this._InvoiceId != value) {
                this._InvoiceId = value;
                this.setEquality(InvoiceHsnRow.Fields.Id, value);
                this.refresh();
            }
        }
    }
}